module.exports = __webpack_public_path__ + "static/media/Privacy Policy-05_26_2020-4.82155752.png";